import { memo } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { useFlags } from '@mint-lib/routing-context';

import { getDescriptionOfIntegration } from '../../../constants/DescriptionsOfIntegrations.js';
import { Platform } from '../../../types/index.js';
import ChannelCard from '../../_organisms/Overview/ChannelCard.jsx';
import Description from '../../_organisms/Overview/Description.jsx';
import PlatformCard from '../../_organisms/Overview/PlatformCard.jsx';
import TypeCard from '../../_organisms/Overview/TypeCard.jsx';

type Props = {
  platform: Platform;
};

const Overview = ({ platform }: Props) => {
  const { t } = useTranslation('@myn/integrations_v2');
  const ff = useFlags('@mint/arm', ['settingsMint2']);
  const isSettingsV2 = ff?.settingsMint2?.enabled;

  return (
    <div
      data-testid="overviewpage-form"
      className="relative mt-6 h-[calc(100vh-320px)] w-full overflow-auto bg-ui-secondary"
    >
      <div className="flex max-w-230 flex-row gap-6">
        {!isSettingsV2 && (
          <div className="flex h-full min-w-50 flex-col gap-4">
            <PlatformCard category={platform?.category || ''} />
            <ChannelCard channels={platform?.channels || []} />
          </div>
        )}
        <div>
          <TypeCard type={platform?.type} />
        </div>
      </div>
      <Description
        description={platform?.description || ''}
        descriptionList={getDescriptionOfIntegration(platform?.platform, t)}
      />
    </div>
  );
};

export default memo(Overview);
